import React from 'react';
import {Link} from 'react-router-dom';
import {getLinkPath} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    FAQPath: string,
}

export default class FAQButton extends React.PureComponent<Props> {
    onClick = (e: React.MouseEvent): void => {
        e.stopPropagation();
    };

    render(): React.ReactNode {
        return <div className="faq-button">
            <Link
                to={getLinkPath(this.props.FAQPath)}
                target="_blank"
                className="act faq-button__icon"
                onClick={this.onClick}
            >
                <SpriteIcon name="#svg-question" size={{height: 20, width: 20}}/>
            </Link>
        </div>;
    }
}
